module.exports = __webpack_public_path__ + "img/questions.07f341fb.svg";